<dv-grid [actions]="actions">
  <ag-grid-angular
    dvGridStandalone
    class="ag-theme-devinco"
    [gridOptions]="gridOptions">
  </ag-grid-angular>
</dv-grid>
